<!-- 会员服务协议页面 -->

<template>
  <div class="agreement">
    <div class="back-btn" @click="goBack">返回</div>
    <div class="title">游密智能变声产品使用及会员服务协议</div>

    <div class="sub-title">序言</div>
    <p>欢迎您（或称“用户”）使用上海游密信息科技有限公司（下称“游密科技”或“我们”）提供的智能变声产品和服务（下称“游密智能变声产品和服务”或“本服务”）。</p>
    <p>本协议由《游密智能变声产品使用及会员服务协议》正文、附件一《连续包月服务规则》（下称“附件一”）、以及游密科技不时公布的各项服务规则组成。</p>
    <p>为使用游密智能变声产品和服务，您应当阅读并遵守《游密智能变声产品使用及会员服务协议》。请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议。免除或限制责任条款可能以加粗等形式提示您注意。</p>
    <p>除非您已阅读并接受本协议所有条款，否则您无权使用游密智能变声产品和服务。您对游密智能变声产品和服务的任何购买或接受赠与等获取行为及登录、查看等任何使用行为即视为您已阅读并同意本协议的约束。如果发生纠纷，您不得以未仔细阅读为由进行抗辩。</p>
    <p>如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。</p>
    <p>根据经营情况的变化，游密科技有权随时更改本协议（包括游密智能变声产品和服务的相关规则），并通过公告、系统消息或邮件等形式公布，修改自公告公布之日、或消息送达至您的邮箱之日起生效。如果您不同意游密科技作出的修改，您可以主动停止使用游密智能变声产品和服务，如果在游密科技修改本协议后，您仍继续使用游密智能变声产品和服务，即表示您同意游密科技对本协议所做的所有修改。</p>

    <div class="sub-title">一、本协议的范围</div>
    <div class="sub-sub-title">1.1适用主体</div>
    <p>本协议是您与游密科技之间关于您使用游密智能变声产品和服务所订立的协议。</p>
    <div class="sub-sub-title">1.2 服务内容</div>
    <p>本协议内容同时包括游密科技可能不断发布的关于游密智能变声产品和服务的相关协议、业务规则等内容。上述内容一经游密科技正式发布，即为本协议不可分割的组成部分，您同样应当遵守。</p>
    <div class="sub-title">二、关于本协议服务</div>
    <div class="sub-sub-title">2.1 变声服务</div>
    <p>变声服务，指在您使用游密科技变声产品网络服务时，游密科技变声产品将自动接收并记录您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；游密科技变声产品通过合法途径从商业伙伴处取得的用户个人数据。</p>
    <div class="sub-sub-title">2.2 会员服务</div>
    <p>包月增值服务，指按照游密科技指定的方式支付一定包月服务费用之后，用户可以享有由游密科技或第三方提供的在游密科技变声产品特权的服务。</p>
    <p>游密科技可能会根据不同的产品及服务类型，推出不同的包月增值服务。游密科技也可能会根据用户的需求、产品及服务类型的变化等，对现有包月增值服务种类进行调整并不断推出新的包月增值服务种类。游密科技也可能会在不同时间推出具体不同的服务内容，以不断完善、优化会员服务。具体包月增值服务种类、服务内容以游密科技相关服务页面公布、实际提供的内容为准。您可以自行根据需要选择相应服务。</p>
    <p>特别提示：在您开通本服务后，游密科技可能会根据本服务的整体规划向您提供各项广告服务。</p>
    <p>您理解并同意：您通过游密科技指定渠道开通本服务后，可能会由于您使用的软件版本、设备、操作系统等不同以及其他第三方原因等导致您实际可使用的具体服务（包括但不限于变声功能等）有差别，由此可能给您带来的不便，您表示理解，并不会因此向游密科技提出任何主张或追究游密科技的任何责任。</p>
    <div class="sub-title">三、权利义务</div>
    <div class="sub-sub-title">3.1 用户信息使用、保护</div>
    <p>3.1.1 为服务用户的目的，游密科技可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与游密科技合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。</p>
    <p>3.1.2 游密科技不会向第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和游密科技（含游密科技关联公司）单独或共同为您提供服务，且在该服务结束后，游密科技将不会访问和保存包括其以前能够访问的所有这些资料。</p>
    <p>3.1.3 游密科技不允许第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何用户如从事前述活动，一经发现，游密科技有权立即终止与该用户的服务协议。同时，游密科技保留追究该用户法律责任的权利。如因此给游密科技、其他用户或第三方造成损失的，该用户应承担全部责任。</p>
    <div class="sub-sub-title">3.2 信息披露</div>
    <p>在如下情况下，游密科技将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
    <p>(1) 经您事先同意，向第三方披露；</p>
    <p>(2) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
    <p>(3) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
    <p>(4) 如您出现违反中国有关法律、法规或者本协议或相关规则的情况，需要向第三方披露；</p>
    <p>(5) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
    <p>(6) 在游密科技平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，游密科技有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</p>
    <p>(7) 其它游密科技根据法律、法规或者网站政策认为合适的披露。</p>
    <div class="sub-sub-title">3.3 信息存储和交换</div>
    <p>游密科技收集的有关您的信息和资料将保存在游密科技及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或游密科技收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>
    <div class="sub-sub-title">3.4 信息安全</div>
    <p>在使用游密科技变声产品网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是用户名及密码发生泄露，请您立即联络游密科技变声产品合作方的客服，以便游密科技及合作方可共同采取相应措施。</p>
    <div class="sub-sub-title">3.5 关于会员收费</div>
    <p>本服务是游密科技提供的收费服务，您须在按照本服务的收费标准支付相应费用后，方可使用本服务。</p>
    <p>游密科技可能会根据本服务的整体规划，对本服务相关权益细则、收费标准、方式等进行修改和变更，前述修改、变更，游密科技将在相应服务页面进行展示。您若需要获取、使用本服务，请先提前了解清楚当时关于本服务的收费标准、方式等信息。</p>
    <div class="sub-sub-title">3.6 会员服务开通</div>
    <p>您应该通过游密科技指定的包括但不限于微信支付、支付宝支付等现有方式或今后游密科技指定方式，在依约支付一定费用后开通本服务。本服务开通之后，不可进行转让或者退订。同时，您不得通过以下任何方式为自己开通本服务：</p>
    <p>(1) 以营利、经营等非个人使用的目的开通本服务；</p>
    <p>(2) 通过任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件等任何程序、软件方式开通本服务；</p>
    <p>(3) 通过任何不正当手段或以违反诚实信用原则的方式开通本服务；</p>
    <p>(4) 通过非游密科技指定的方式开通本服务；</p>
    <p>(5) 通过侵犯游密科技或他人合法权益的方式开通本服务；</p>
    <p>(6) 通过其他违反相关法律、行政法规、国家政策等方式开通本服务。</p>
    <div class="sub-sub-title">3.7 会员服务期限</div>
    <p>3.7.1会员服务期限以您自行选择并支付相应服务费用的期限为准，您也可以登陆本服务的相应页面查询。</p>
    <p>3.7.2本服务的服务开通最高期限会受到一定限制，具体以游密科技制定的的规则为准。</p>
    <div class="sub-sub-title">3.8 用户行为规范</div>
    <p>3.8.1 您在使用本服务时不得利用本服务从事以下行为，包括但不限于：</p>
    <p>(1) 发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；</p>
    <p>(2) 发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
    <p>(3) 虚构事实、隐瞒真相以误导、欺骗他人；</p>
    <p>(4) 发表、传送、传播广告信息及垃圾信息；</p>
    <p>(5) 从事其他违反法律法规、政策及公序良俗、社会公德等的行为。</p>
    <p>3.8.2 本服务仅供您个人使用，除非经游密科技书面许可，您不得进行以下行为：</p>
    <p>(1) 通过任何方式搜集本服务中其他用户的用户名、电子邮件等相关信息，并以发送垃圾邮件、连锁邮件、垃圾短信、即时消息等方式干扰、骚扰其他用户；</p>
    <p>(2) 通过本服务发布包含广告、宣传、促销等内容的信息；</p>
    <p>(3) 将本服务再次许可他人使用；</p>
    <p>(4) 其他未经游密科技书面许可的行为。</p>
    <p>3.8.3 您充分了解并同意，您必须为自己帐号下的一切行为负责，包括但不限于您所发表的任何内容以及由此产生的任何后果。您应对游密科技变声产品服务、变声会员服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。</p>
    <div class="sub-sub-title">
      <strong>3.9 您充分了解并同意，由于互联网服务的特殊性，游密科技可能会按照相关法规、双方约定或在其他必要时，中止或终止向您提供本服务，届时，游密科技会依法保护您的合法权益。</strong>
    </div>
    <div class="sub-title">四、违约责任</div>
    <div class="sub-sub-title">
      <strong>4.1如果游密科技发现或收到他人举报您有违反本协议任何行为的，游密科技有权依法进行独立判断并采取技术手段予以删除、屏蔽或断开相关的信息。同时，游密科技有权视您的行为性质，对您采取包括但不限于暂停或终止部分或全部本服务、中止或终止您对变声功能使用、追究您法律责任等措施，游密科技也无需向您退还任何费用，而由此给您带来的损失（包括但不限于使用中断、相关数据清空、未使用的服务费用作为违约金而归游密科技所有等），由您自行承担，造成游密科技损失的，您也应予以赔偿。</strong>
    </div>
    <div class="sub-sub-title">4.2 您有违反本协议任何行为，导致任何第三方损害的，您应当独立承担责任；游密科技因此遭受损失的，您也应当一并赔偿。</div>
    <div class="sub-title">五、知识产权</div>
    <div
      class="sub-sub-title"
    >5.1 游密智能变声产品和服务相关的知识产权，包括但不限于著作权、商标权、专利权、商业秘密、技术秘密、以及其他内容（包括但不限于文字、图片、音频、视频、界面设计、相关数据或电子文档等），均为游密科技或其权利人所有，受中华人民共和国法律或相关国际条约的保护。</div>
    <div class="sub-sub-title">5.2 游密智能变声产品和服务可能涉及第三方知识产权，您在使用游密智能变声产品和服务时应注意并遵守第三方知识产权的相关规定。</div>
    <div class="sub-title">六、适用法律及争议解决</div>
    <div class="sub-sub-title">6.1 本协议的订立、效力、解释、履行及争议解决适用中华人民共和国法律。</div>
    <div class="sub-sub-title">6.2 若您和游密科技之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</div>
    <div class="sub-title">七、其他</div>
    <div class="sub-sub-title">7.1 您使用本服务即视为您已阅读并同意受本协议的约束。</div>
    <div class="sub-sub-title">7.2 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</div>
    <div class="sub-sub-title">7.3 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</div>
    <div class="sub-sub-title">7.4 在法律允许的范围内，游密科技享有对本协议条款的解释权。</div>
    <div class="sub-sub-title">(正文完)</div>
    <br>
    <br>
    <div class="end-company">上海游密信息科技有限公司</div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <div class="title">附件一 连续包月服务规则</div>
    <p>
      本《连续包月服务规则》（下称“本规则”）被视为本协议的附件，如本规则与《游密智能变声产品使用及会员服务协议》存在冲突的，以本规则为准。
      如您需使用智能变声VIP连续包月服务，则需同意本规则。
    </p>
    <p>您理解并同意：</p>
    <p>1.本服务是在您已开通智能变声VIP会员服务的前提下，为您提供的自动续费服务。如您开通本服务，则视为您授权游密科技在您的智能变声VIP会员即将到期时，从您的与会员账号绑定的第三方支付账户余额中代扣下一个计费周期包月费。该服务实现的前提是您已将智能变声VIP会员账号与上述账户绑定，且可成功从上述账户中扣款，因上述账户中可扣款余额不足导致的续费失败，由您自行承担。</p>
    <p>2.您可通过下述方式中止或终止本服务：</p>
    <p>微信支付自动续费用户退订方法：在“微信支付”公众号中，选择“自动扣费”，根据页面显示进行解约，解约后服务到期将不再自动续费。</p>
    <p>您可以在手机客户端，智能变声会员首页，选择“管理自动续费”，关闭自动续费，关闭后服务到期将不再自动续费。</p>
    <p>自动续费状态状态更新可能存在显示延时，以微信支付自动续费签约状态为准。</p>
    <br>
    <br>
    <div class="end-company">上海游密信息科技有限公司</div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  name: "Agreement",
  methods: {
    goBack: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.agreement {
  width: 100%;
  padding: 0.3rem;
  box-sizing: border-box;
  font-size: 0.17rem;
  color: #232220;
  .back-btn {
    height: 0.23rem;
    line-height: 0.23rem;
    width: 0.6rem;
    padding-left: 0.2rem;
    font-size: 0.2rem;
    text-align: left;
    background-image: url("../assets/back_000.svg");
    background-repeat: no-repeat;
    background-size: 0.13rem 0.23rem;
    background-position: top left;
    color: #232220;
    margin: 0 0 0.23rem 0;
  }
  .title {
    font-size: 0.22rem;
    text-align: center;
    line-height: 0.3rem;
    padding-bottom: 0.22rem;
    font-weight: bold;
  }
  .sub-title {
    font-weight: bold;
    text-align: left;
    line-height: 0.24rem;
    padding-bottom: 0.1rem;
  }
  p {
    line-height: 0.24rem;
    text-indent: 0.34rem;
    white-space: normal;
    text-align: left;
    margin: 0 0 0.17rem;
  }
  .sub-sub-title {
    line-height: 0.24rem;
    text-indent: 0.34rem;
    white-space: normal;
    text-align: left;
    margin: 0 0 0.17rem;
  }
  .end-company {
    text-align: right;
  }
}
</style>
